import { RecordQ } from "@pdfking/structs"

import { WORKER_MARKER } from "../../internal/WorkerMarker"

export const IsWorker = (): boolean => RecordQ(self) && self.name === WORKER_MARKER
